var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(!_vm.isMobile && _vm.browserSupported)?_vm._t("default"):(_vm.isMobile)?_c('mobile-not-supported'):(!_vm.isMobile && !_vm.browserSupported)?_c('browser-not-supported'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }